import Page from './index';
export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	routes: [
		{
			path: '/accessories',
			exact: true,
			component: Page.Layout
		},
	]
};